/* eslint-disable import/prefer-default-export */
export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/3fa646a3-bd07-4f89-8a1a-3e7385b21609.png',
};
